import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "./firebase"; // Ajusta la ruta relativa si es necesario según la ubicación de tu carpeta services
import { auth } from "./firebase";

/**
 * Resolve the current user's id from whichever shape happens to be handy —
 * the userData object from context (which may use "uid" or "id" depending
 * on where it was hydrated from), falling back to the live Firebase Auth
 * session. Centralizes a fallback chain that used to be copy-pasted in
 * eight different components/hooks.
 */
export function getCurrentUserId(userData) {
  return userData?.uid || userData?.id || auth.currentUser?.uid || null;
}

/**
 * Save or update user profile data (including interests) in Firestore.
 * @param {string} uid - The unique ID of the authenticated user.
 * @param {Object} userData - Object containing user data (name, gender, avatar, interests, etc.)
 */
export async function saveUserToFirestore(uid, userData) {
  try {
    const userRef = doc(db, "users", uid);
    // Using { merge: true } to update only modified fields without overwriting the whole document
    await setDoc(userRef, userData, { merge: true });
    console.log("User preferences successfully saved to Firestore!");
  } catch (error) {
    console.error("Error saving user to Firestore:", error);
    throw error;
  }
}

/**
 * Retrieve user profile data from Firestore.
 * @param {string} uid - The unique ID of the user.
 */
export async function getUserFromFirestore(uid) {
  try {
    const userRef = doc(db, "users", uid);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      return userSnap.data();
    } else {
      console.log("No user profile found in Firestore for this ID.");
      return null;
    }
  } catch (error) {
    console.error("Error fetching user from Firestore:", error);
    return null;
  }
}
